import { createSlice } from "@reduxjs/toolkit";

export type Client = {
  id: number;
  country_code: string;
  phone_number: string;
  phone?: string;
  email: string;
  first_name: string;
  last_name: string;
  company_id: number | null;
  broker_id: number | null;
  assigned_user_id: number | null;
  created_by_id: number | null;
  updated_by_id: number | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  assigned_user?: {
    full_name?: string;
  } | null;
};

export type ClientList = {
  total: number;
  page: number;
  page_size: number;
  data: Client[];
};

export type ClientState = {
  clientList: ClientList | null;
};

const initialState: ClientState = { clientList: null };

const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    clientList: (state, action: { payload: ClientState["clientList"] }) => {
      state.clientList = action.payload;
    },
  },
});

export const { clientList } = clientSlice.actions;
export default clientSlice.reducer;
